export default class Modals {
  constructor() {
    this.triggers = document.querySelectorAll('[data-modal]')
    this.activeModals = []
    this.iframes = new Map()

    if (!this.triggers) return

    this.initHandlers()
    this.initTriggers()
  }

  initHandlers() {
    const close = (e) => {
      const valid =
        e.key == 'Escape' ||
        e.target.closest('.is-exit') ||
        e.target.classList.contains('modal-background')

      if (valid && this.activeModals.length > 0) {
        // Get the topmost (most recently opened) modal
        const currentModal = this.activeModals[this.activeModals.length - 1]

        // Remove the modal from active state
        currentModal.classList.remove('is-active')
        currentModal.removeEventListener('click', this.closeHandler)

        // Remove from active modals array
        this.activeModals.pop()

        // Handle iframe cleanup
        const iframe = this.iframes.get(currentModal)
        if (iframe) {
          iframe.src = ''
          this.iframes.delete(currentModal)
        }

        // Only remove body clipping if no modals are active
        if (this.activeModals.length === 0) {
          document.documentElement.classList.remove('is-clipped')
          document.removeEventListener('keyup', this.closeHandler)
        }
      }
    }

    this.closeHandler = close.bind(this)
  }

  initTriggers() {
    this.triggers.forEach((e) => {
      e.addEventListener('click', () => {
        const modal = document.querySelector(
          '.modal[data-id=' + e.dataset.modal + ']'
        )

        if (modal) {
          // Add to active modals stack
          this.activeModals.push(modal)

          // Only add body clipping and keyup listener if this is the first modal
          if (this.activeModals.length === 1) {
            document.documentElement.classList.add('is-clipped')
            document.addEventListener('keyup', this.closeHandler)
          }

          modal.classList.add('is-active')
          modal.addEventListener('click', this.closeHandler)

          const inputElement = modal.querySelector('input')
          if (inputElement) inputElement.focus()

          const iframe = modal.querySelector('iframe')
          if (iframe) {
            iframe.src = iframe.dataset.src
            this.iframes.set(modal, iframe)
          }
        }
      })
    })
  }
}
